import { Component } from '@angular/core';
import { RadioTabModel } from '@app/features/app-content/models/app-tabs.model';
import { AppConfigurationState } from '@app/features/app-content/states/app-configuration.state';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'rk-player-content',
  templateUrl: './player-content.component.html',
  styleUrl: './player-content.component.scss',
  standalone: false,
})
export class PlayerContentComponent {
  @Select(AppConfigurationState.currentAppConfigPlayerTab)
  currentAppConfigPlayerTab$: Observable<RadioTabModel>;
}
